module.exports = __webpack_public_path__ + "static/Metropolis-SemiBold-2556a4f74e2c523893e6928d6e300f1c.otf";